import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  ILatLng,
  Marker,
  BaseArrayClass,
  GoogleMapOptions,
  LatLng,
  CameraPosition,
  MarkerOptions
} from '@ionic-native/google-maps';
import { Observable } from 'rxjs';


@Component({
  selector: 'page-marker',
  templateUrl: 'marker.html',
})
export class MarkerPage {

  map: GoogleMap;
  runner: Marker;
  private selfmarker : Marker;
  lng: number = 106.817162;
  lat: number = -6.195660;
  data_point = [];
  markers: any = [];
  constructor() {
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad MarkerPage');
    this.loadMap();
    let sub = Observable.interval(1000).subscribe((val) => { this.gameloop(); })
  }

  loadMap() {
    let POINTS = [
      {
        position: {lat:41.79883, lng:140.75675},
        iconData: "./assets/imgs/Number-1-icon.png"
      },
      {
        position: {lat:41.799240000000005, lng:140.75875000000002},
        iconData: "http://icons.iconarchive.com/icons/iconarchive/red-orb-alphabet/24/Number-2-icon.png"
      },
      {
        position: {lat:41.797650000000004, lng:140.75905},
        iconData: {
          url: "http://icons.iconarchive.com/icons/iconarchive/red-orb-alphabet/48/Number-3-icon.png",
          size: {
            width: 24,
            height: 24
          }
        }
      },
      {
        position: {lat:41.79637, lng:140.76018000000002},
        title: "4",
        iconData: "blue"
      },
      {
        position: {lat:41.79567, lng:140.75845},
        title: "5",
        iconData:  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAACVUlEQVRIS8WWjVXCMBRGwwTqBMIEuAG4ARuIE6gTKBOgEyAT4AbABjKBMIE/C+h3m6S2pWlJ8BzfOTkpad6770teEzom3bZy/VbrpYTopDjJZ6w2c77X6p9j46SCUXvuYDxHq04BZ2rPHXa3y/DRqlPAmdqZW+hrkMZEq44F52q3oGTdrjEpqmPBudoxKVBVKqsU1THgPbW+klNUt4GHCn6idqEGuMveerUeXFGtNTCvah9qaz+n2gMmKMGBnLrfjPFcMirZ7231XUF19RUJkIhPZqXnT8AM9Osy62v0VPihUqIfjWwx1RkJvbxIpjArhabfbEJ6zQYwysiiT3CW8kJ6Q4BgqMALEnqVNAqQZGSkM/R7nMOBLhZ/B/ZQeg9V/1EsrpLy5dIqP8aAXV6WlQIlZrWq/wzeBK0DM3Y0vA0aAh8FPwTaBC7B2W8+qUOMT4l9dYUUrJK2k4tCOHl7O7zK+Xx69nbWU/iebgKz1+9E+OYPToR1fqOe+SquujeBWdzlYGBPohhjW9b2lGbRa72bwLdyml5d2auvaPyeTOzIw4MxzCkal8h8no3cqT3WJd0ExuFmOjXmlhRIXbnfKZQ7hfJ4HDTM8wVIMi6xJ01y3mV8E5glGlDRGIEKS75DrAtFn/0DA3x/b0ddZbPgGt23JnBW0agpKPzUGCvhoT4iv1HG9Zodtc6HGBTYnoXAXc3UR5SbBwK1d8y+8RUAzxNwU2orOwQeyolF/lLT7mUqQ8BqCj4Bt+j1lR0Cs3Sopt8GFLYNF/2JU7K2k6stePL7fwP/AER2xy+mY1/QAAAAAElFTkSuQmCC"
      }
    ];

    this.data_point = POINTS;

    let bounds: ILatLng[] = this.data_point.map((data: any, idx: number) => {
      console.log(data);
      return data.position;
    });

    this.map = GoogleMaps.create('map_canvas'
    , {
      camera: {
        target: bounds
      }
    }
    );
    
    this.data_point.forEach((data: any) => {
      data.disableAutoPan = true;
      // data.position.lat += myArray[Math.floor(Math.random() * myArray.length)];
      // data.position.lng += myArray[Math.floor(Math.random() * myArray.length)];
      
      this.map.addMarker(data).then((marker) => {
        this.markers.push(marker);
      });
      // marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(this.onMarkerClick);
      // marker.on(GoogleMapsEvent.INFO_CLICK).subscribe(this.onMarkerClick);
    });

  }


gameloop() {
  this.map.clear();
  // if(this.markers.length > 0){
  //   this.markers.forEach(row => {
  //     console.log(row);
  //     row.setMap(null);
  //   });
  // }
  let myArray = [0.0001,0.0010,0.0002,0.0003];
  this.data_point.forEach((data: any) => {
    data.disableAutoPan = true;
    console.log('data',data);
    data.position.lat += myArray[Math.floor(Math.random() * myArray.length)];
    data.position.lng += myArray[Math.floor(Math.random() * myArray.length)];
    this.map.addMarker(data).then((marker) => {
      this.markers.push(marker);
    });
  });
}
}


// WEBPACK FOOTER //
// ./src/pages/activity/marker/marker.ts